import React from "react";

export default function Performance() {
  return <div>Coming soon...</div>;
}
